import { render } from "./adminprojects.vue?vue&type=template&id=32d310f3"
import script from "./adminprojects.vue?vue&type=script&lang=js"
export * from "./adminprojects.vue?vue&type=script&lang=js"

import "./adminprojects.vue?vue&type=style&index=0&id=32d310f3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__